import React, { useCallback, useMemo } from "react";
import { useWizard } from 'components/wizard/WizardContext';
import { Card } from "reactstrap";
import { useFetchVendorStudentMappings } from "../customHook";
import { getPaymentMappingPayload } from "../helper";
import ALoader from "views/pages/manage/common/a-loader";
import ListComponent from "./ListComponent";
import { formattedPrice } from "views/pages/manage/unAssigned/collectPayment/utils";
import styles from "../styles.module.scss";
import { endpoint } from "views/pages/manage/common/constant";

const StudentMappedDetails = ({ stream }) => {
    const { fetchStudentMappingList } = useFetchVendorStudentMappings();
    const { values } = useWizard();
    const vendorType = values?.vendorType;
    const streamKey = stream?.label;
    const streamData = values?.[streamKey];

    const vendorId = values?.vendorDetails?.id;
    const businessAreaId = values?.addVendorForm?.businessArea?.value;
    const yearId = values?.addVendorForm?.year?.value;

    const tableHeading = vendorType !== 'INVIGILATOR' ? `Students mapped • ${streamKey}` : `Exams & pay hours • ${streamKey}`

    const payload = useMemo(() => {
        if (!vendorId || !businessAreaId || !yearId) return null;

        return getPaymentMappingPayload(
            {
                vendorDetails: values?.vendorDetails,
                addVendorForm: values?.addVendorForm
            },
            stream
        );
    }, [vendorId, businessAreaId, yearId, stream?.value]);

    const nextButtonHandler = useCallback(
        (newPage, pageSize) => {
            if (!payload) return;

            const url = vendorType?.toUpperCase() == 'INVIGILATOR' ? endpoint.raiseVendorRequest?.invigilator?.search : endpoint.raiseVendorRequest?.admissionAdvisor?.search

            fetchStudentMappingList(
                url,
                payload,
                newPage,
                pageSize,
                streamKey
            );
        },
        [payload, streamKey, fetchStudentMappingList]
    );

    if (!streamData?.hasData) return null;

    return (
        <>
            {streamData?.loading && <ALoader position="fixed" />}

            <Card >
                <div className="d-flex justify-content-between " style={{ margin: "18px" }}>
                    <h4>{tableHeading}</h4>
                    <div>
                        Total Amount <span className={styles['amount']}>{formattedPrice(streamData?.totalAmount)}</span>
                    </div>
                </div>

                <ListComponent
                    rows={streamData?.list}
                    paginationInfo={streamData?.paginationInfo}
                    // rowCount={streamData?.paginationInfo?.totalRecords}
                    // currentPage={streamData?.paginationInfo?.currentPage}
                    // currPageSize={streamData?.paginationInfo?.pageSize}
                    nextButtonHandler={nextButtonHandler}
                    loading={streamData?.loading}
                />
            </Card>
        </>
    );
};

export default React.memo(StudentMappedDetails);
